var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{nativeOn:{"click":function($event){return _vm.goBackToCall.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t("agent-console.transfer.go-back-to-call"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }